import { CategoryData } from '../../../../types/types';

export const objets: CategoryData = {
  'Nyumba (Maison)': {
    translation: 'La maison',
    translationEn: 'The house',
    illustration: '🏠',
    example: 'Nyumba ni nzuri. (La maison est belle.)',
    exampleEn: 'Nyumba ni nzuri. (The house is beautiful.)'
  },
  'Kitabu (Livre)': {
    translation: 'Le livre',
    translationEn: 'The book',
    illustration: '📖',
    example: 'Ninasoma kitabu. (Je lis un livre.)',
    exampleEn: 'Ninasoma kitabu. (I am reading a book.)'
  },
  'Meza (Table)': {
    translation: 'La table',
    translationEn: 'The table',
    illustration: '🪑',
    example: 'Meza ni safi. (La table est propre.)',
    exampleEn: 'Meza ni safi. (The table is clean.)'
  },
  'Kiti (Chaise)': {
    translation: 'La chaise',
    translationEn: 'The chair',
    illustration: '🪑',
    example: 'Kiti kiko hapa. (La chaise est ici.)',
    exampleEn: 'Kiti kiko hapa. (The chair is here.)'
  },
  'Funguo (Clé)': {
    translation: 'La clé',
    translationEn: 'The key',
    illustration: '🔑',
    example: 'Nina funguo. (J’ai la clé.)',
    exampleEn: 'Nina funguo. (I have the key.)'
  },
  'Gari (Voiture)': {
    translation: 'La voiture',
    translationEn: 'The car',
    illustration: '🚗',
    example: 'Gari limefika. (La voiture est arrivée.)',
    exampleEn: 'Gari limefika. (The car has arrived.)'
  },
  'Simu (Téléphone)': {
    translation: 'Le téléphone',
    translationEn: 'The phone',
    illustration: '📱',
    example: 'Simu haifanyi kazi. (Le téléphone ne marche pas.)',
    exampleEn: 'Simu haifanyi kazi. (The phone is not working.)'
  },
  'Mlango (Porte)': {
    translation: 'La porte',
    translationEn: 'The door',
    illustration: '🚪',
    example: 'Mlango umefungwa. (La porte est fermée.)',
    exampleEn: 'Mlango umefungwa. (The door is closed.)'
  },
  'Dirisha (Fenêtre)': {
    translation: 'La fenêtre',
    translationEn: 'The window',
    illustration: '🪟',
    example: 'Dirisha limefunguliwa. (La fenêtre est ouverte.)',
    exampleEn: 'Dirisha limefunguliwa. (The window is open.)'
  },
  'Sufuria (Marmite)': {
    translation: 'La marmite',
    translationEn: 'The cooking pot',
    illustration: '🍲',
    example: 'Sufuria ipo jikoni. (La marmite est dans la cuisine.)',
    exampleEn: 'Sufuria ipo jikoni. (The pot is in the kitchen.)'
  },
  'Glasi (Verre)': {
    translation: 'Le verre',
    translationEn: 'The glass',
    illustration: '🥛',
    audio: 'Sw-Glasi',
    example: 'Glasi imevunjika. (Le verre est cassé.)',
    exampleEn: 'Glasi imevunjika. (The glass is broken.)'
  },
  'Maji (Eau)': {
    translation: 'L’eau',
    translationEn: 'Water',
    illustration: '💧',
    audio: 'Sw-Maji',
    example: 'Maji ni baridi. (L’eau est froide.)',
    exampleEn: 'Maji ni baridi. (The water is cold.)'
  },
  'Wali (Riz)': {
    translation: 'Le riz',
    translationEn: 'Rice',
    illustration: '🍚',
    audio: 'Sw-Wali',
    example: 'Wali ni mtamu. (Le riz est délicieux.)',
    exampleEn: 'Wali ni mtamu. (The rice is delicious.)'
  },
  'Nyama (Viande)': {
    translation: 'La viande',
    translationEn: 'Meat',
    illustration: '🥩',
    audio: 'Sw-Nyama',
    example: 'Nyama inaiva jikoni. (La viande cuit dans la cuisine.)',
    exampleEn: 'Nyama inaiva jikoni. (The meat is cooking in the kitchen.)'
  },
  'Moto (Feu)': {
    translation: 'Le feu',
    translationEn: 'Fire',
    illustration: '🔥',
    example: 'Moto unawaka. (Le feu est allumé.)',
    exampleEn: 'Moto unawaka. (The fire is burning.)'
  },
  'Mkaa (Charbon)': {
    translation: 'Le charbon de bois',
    translationEn: 'Charcoal',
    illustration: '⚫',
    example: 'Mkaa ni mwingi. (Il y a beaucoup de charbon.)',
    exampleEn: 'Mkaa ni mwingi. (There is a lot of charcoal.)'
  },
  'Kitenge (Tissu)': {
    translation: 'Le tissu',
    translationEn: 'The fabric',
    illustration: '🧵',
    example: 'Kitenge ni kizuri. (Le tissu est beau.)',
    exampleEn: 'Kitenge ni kizuri. (The fabric is beautiful.)'
  },
  'Nguo (Vêtement)': {
    translation: 'Le vêtement',
    translationEn: 'The garment',
    illustration: '👕',
    example: 'Nguo ni safi. (Le vêtement est propre.)',
    exampleEn: 'Nguo ni safi. (The garment is clean.)'
  },
  'Suruali (Pantalon)': {
    translation: 'Le pantalon',
    translationEn: 'The trousers',
    illustration: '👖',
    example: 'Suruali ni nzuri. (Le pantalon est beau.)',
    exampleEn: 'Suruali ni nzuri. (The trousers are nice.)'
  },
  'Shati (Chemise)': {
    translation: 'La chemise',
    translationEn: 'The shirt',
    illustration: '👔',
    example: 'Shati ni safi. (La chemise est propre.)',
    exampleEn: 'Shati ni safi. (The shirt is clean.)'
  },
  'Kanzu (Boubou)': {
    translation: 'Le boubou',
    translationEn: 'The kanzu robe',
    illustration: '🥻',
    example: 'Kanzu ni ndefu. (Le boubou est long.)',
    exampleEn: 'Kanzu ni ndefu. (The robe is long.)'
  },
  'Pesa (Argent)': {
    translation: 'L’argent',
    translationEn: 'Money',
    illustration: '💰',
    example: 'Sina pesa. (Je n’ai pas d’argent.)',
    exampleEn: 'Sina pesa. (I have no money.)'
  },
  'Mashua (Pirogue)': {
    translation: 'La pirogue',
    translationEn: 'The canoe',
    illustration: '🛶',
    example: 'Mashua imeondoka. (La pirogue est partie.)',
    exampleEn: 'Mashua imeondoka. (The canoe has left.)'
  },
  'Teksi (Taxi)': {
    translation: 'Le taxi',
    translationEn: 'The taxi',
    illustration: '🚕',
    example: 'Teksi imeondoka. (Le taxi est parti.)',
    exampleEn: 'Teksi imeondoka. (The taxi has left.)'
  },
  'Wavu (Filet)': {
    translation: 'Le filet',
    translationEn: 'The net',
    illustration: '🥅',
    example: 'Wavu umeharibika. (Le filet est abîmé.)',
    exampleEn: 'Wavu umeharibika. (The net is damaged.)'
  },
  'Barua (Lettre)': {
    translation: 'La lettre',
    translationEn: 'The letter',
    illustration: '✉️',
    example: 'Barua imefika. (La lettre est arrivée.)',
    exampleEn: 'Barua imefika. (The letter has arrived.)'
  },
  'Kisu (Couteau)': {
    translation: 'Le couteau',
    translationEn: 'The knife',
    illustration: '🔪',
    audio: 'Sw-Kisu',
    example: 'Kisu ni kikubwa. (Le couteau est grand.)',
    exampleEn: 'Kisu ni kikubwa. (The knife is big.)'
  },
  'Chumba (Chambre)': {
    translation: 'La chambre',
    translationEn: 'The room',
    illustration: '🛏️',
    example: 'Chumba ni safi. (La chambre est propre.)',
    exampleEn: 'Chumba ni safi. (The room is clean.)'
  },
  'Bustani (Jardin)': {
    translation: 'Le jardin',
    translationEn: 'The garden',
    illustration: '🌱',
    example: 'Bustani ni kubwa. (Le jardin est grand.)',
    exampleEn: 'Bustani ni kubwa. (The garden is big.)'
  },
  'Barabara (Route)': {
    translation: 'La route',
    translationEn: 'The road',
    illustration: '🛣️',
    example: 'Barabara ni ndefu. (La route est longue.)',
    exampleEn: 'Barabara ni ndefu. (The road is long.)'
  },
  'Mji (Ville)': {
    translation: 'La ville',
    translationEn: 'The town',
    illustration: '🏙️',
    example: 'Mji ni mkubwa. (La ville est grande.)',
    exampleEn: 'Mji ni mkubwa. (The town is big.)'
  },
  'Soko (Marché)': {
    translation: 'Le marché',
    translationEn: 'The market',
    illustration: '🏪',
    example: 'Soko limejaa watu. (Le marché est bondé de monde.)',
    exampleEn: 'Soko limejaa watu. (The market is crowded with people.)'
  },
  'Stesheni (Gare)': {
    translation: 'La gare',
    translationEn: 'The station',
    illustration: '🚉',
    example: 'Stesheni ipo pale. (La gare est là-bas.)',
    exampleEn: 'Stesheni ipo pale. (The station is over there.)'
  },
  'Treni (Train)': {
    translation: 'Le train',
    translationEn: 'The train',
    illustration: '🚂',
    example: 'Treni imeondoka. (Le train est parti.)',
    exampleEn: 'Treni imeondoka. (The train has left.)'
  },
  'Ndege (Avion)': {
    translation: 'L’avion',
    translationEn: 'The airplane',
    illustration: '✈️',
    audio: 'Sw-Ndege',
    example: 'Ndege imewasili. (L’avion est arrivé.)',
    exampleEn: 'Ndege imewasili. (The airplane has arrived.)'
  },
  'Msikiti (Mosquée)': {
    translation: 'La mosquée',
    translationEn: 'The mosque',
    illustration: '🕌',
    example: 'Msikiti ni mzuri. (La mosquée est belle.)',
    exampleEn: 'Msikiti ni mzuri. (The mosque is beautiful.)'
  },
  'Shule (École)': {
    translation: 'L’école',
    translationEn: 'The school',
    illustration: '🏫',
    example: 'Shule ni kubwa. (L’école est grande.)',
    exampleEn: 'Shule ni kubwa. (The school is big.)'
  },
  'Ujenzi (Construction)': {
    translation: 'La construction',
    translationEn: 'The construction',
    illustration: '🏗️',
    example: 'Ujenzi umekamilika. (La construction est terminée.)',
    exampleEn: 'Ujenzi umekamilika. (The construction is complete.)'
  },
  'Jiko (Fourneau)': {
    translation: 'Le fourneau',
    translationEn: 'The stove',
    illustration: '🔥',
    example: 'Jiko limewashwa. (Le fourneau est allumé.)',
    exampleEn: 'Jiko limewashwa. (The stove is lit.)'
  },
  'Gereji (Garage)': {
    translation: 'Le garage',
    translationEn: 'The garage',
    illustration: '🏠',
    example: 'Gereji ipo nyuma ya nyumba. (Le garage est derrière la maison.)',
    exampleEn: 'Gereji ipo nyuma ya nyumba. (The garage is behind the house.)'
  },
  'Mchezo (Jeu)': {
    translation: 'Le jeu',
    translationEn: 'The game',
    illustration: '🎮',
    example: 'Mchezo ni wa kufurahisha. (Le jeu est amusant.)',
    exampleEn: 'Mchezo ni wa kufurahisha. (The game is fun.)'
  }
};

export default objets;
